const FormFieldLabels: {[key: string]: string} = {
  physical_address: 'Адрес местонахождения',
};

const getFormFieldLabels = (name: string)
  : string => FormFieldLabels[name] ?? `Имя поля не найденно: ${name}`;

export default getFormFieldLabels;
